import { useEffect, useState } from 'react';
import { isValidDateString } from '../../../lib/util/dateFormatter';

const useLXDateInputController = (
  onDateChange: (date?: Date) => void,
  base?: Date
) => {
  const [year, setYear] = useState(base?.getFullYear().toString() ?? '');
  const [isYearValid, setIsYearValid] = useState(base !== undefined);
  const [month, setMonth] = useState(
    base ? (base?.getMonth() + 1).toString() : ''
  );
  const [isMonthValid, setIsMonthValid] = useState(base !== undefined);
  const [day, setDay] = useState(base?.getDate().toString() ?? '');
  const [isDayValid, setIsDayValid] = useState(base !== undefined);

  useEffect(() => {
    if (
      isYearValid &&
      isMonthValid &&
      isDayValid &&
      isValidDateString(year + '-' + month + '-' + day)
    ) {
      onDateChange(new Date(new Date(year + '-' + month + '-' + day)));
    } else {
      onDateChange(undefined);
    }
  }, [year, isYearValid, month, day, isMonthValid, isDayValid, onDateChange]);

  return {
    year,
    isYearValid,
    month,
    day,
    isMonthValid,
    isDayValid,
    setDay,
    setMonth,
    setYear,
    setIsDayValid,
    setIsMonthValid,
    setIsYearValid,
  };
};

export default useLXDateInputController;
